'use es6';

import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultWhatToExpect = () => {
  return /*#__PURE__*/_jsx("b", {
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "InboxConnectUtils.wizard.connectInbox.whatToExpect"
    })
  });
};
function WhatToExpect({
  content
}) {
  if (!content) {
    return /*#__PURE__*/_jsx(DefaultWhatToExpect, {});
  }
  return /*#__PURE__*/_jsx("div", {
    children: content
  });
}
export default WhatToExpect;